var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.rango_temporal == 'dia-en-especifico')?_c('b-form-group',{attrs:{"label":"En la fecha"}},[_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.mes_inicio),callback:function ($$v) {_vm.mes_inicio=$$v},expression:"mes_inicio"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }